import { ErrorConfigurationSchema } from 'CtxErrorMapper/errorConfigSchema';
import { platform } from 'Environment/launchResource/constants';

export type StoreFrontErrorDetail =
	ErrorConfigurationSchema['errorDomain']['StoreFront'][string];

export type LocalizedType = ErrorConfigurationSchema['localized'];

export type RemediationOSName =
	| 'iOS'
	| 'MacOS'
	| 'Windows'
	| 'Linux'
	| 'Android'
	| 'Wasm';

// allow-unused-export: our linter is broken. gives unused error for this.
export const platformToOSMap: Record<string, RemediationOSName> = {
	[platform.windows]: 'Windows',
	[platform.windowsMobile]: 'Windows',
	[platform.mac]: 'MacOS',
	[platform.nativeWidget]: 'MacOS',
	[platform.android]: 'Android',
	[platform.androidTablet]: 'Android',
	[platform.ios]: 'iOS',
	[platform.ipadOS]: 'iOS',
	[platform.linux]: 'Linux',
	[platform.chromeOS]: 'Wasm', // Get this confirmed if ChromeOS should be treated like WASM
};
